import isScreen from "@/core/screenHelper";

export default {
  namespaced: true,
  state: {
    sidebarClose: true,
    sidebarStatic: false,
    sidebarActiveElement: null,
    hideInactiveCircuits: true
  },
  mutations: {
    toggleSidebar(state) {
      const nextState = !state.sidebarStatic;

      localStorage.sidebarStatic = nextState;
      state.sidebarStatic = nextState;

      if (!nextState && (isScreen("lg") || isScreen("xl"))) {
        state.sidebarClose = true;
      }
    },
    toggleInactiveCircuit(state, value) {
      state.hideInactiveCircuits = value
    },
    switchSidebar(state, value) {
      if (value) {
        state.sidebarClose = value;
      } else {
        state.sidebarClose = !state.sidebarClose;
      }
    },
    setSidebarState(state, value) {
      state.sedebarClose = value;
    },
    handleSwipe(state, e) {
      if (e.direction === 4 && !state.chatOpen) {
        state.sidebarClose = false;
      }

      if (e.direction === 2 && !state.sidebarClose) {
        state.sidebarClose = true;
        return;
      }

      state.chatOpen = e.direction === 2;
    },
    changeSidebarActive(state, index) {
      state.sidebarActiveElement = index;
    }
  },
  actions: {
    toggleInactiveCircuit({commit}, value) {
      commit("toggleInactiveCircuit", value)
    },
    toggleSidebar({commit}) {
      commit("toggleSidebar");
    },
    switchSidebar({commit}, value) {
      commit("switchSidebar", value);
    },
    handleSwipe({commit}, e) {
      commit("handleSwipe", e);
    },
    changeSidebarActive({commit}, index) {
      commit("changeSidebarActive", index);
    }
  }
};
